import React, { FC, useState } from 'react'
import Flatpickr from "react-flatpickr";

import * as a from '../' 

type Props = {
    formik: any,
    field: any,
    fieldProps: any
    touched?: any
    errors?: any
    displayText?: string
    verticalLabel?: boolean
}

export const AncientInputDatePicker: React.FC<Props> = ({ formik, field,displayText, fieldProps, touched, errors, verticalLabel }) => {
    const [date, setDate] = useState<Date>()

    const dateUpdate = (date: Date) => {
        console.log(date)
        formik.setFieldValue(field, new Date(date).toISOString());
    }


    const datePicker = () => {
        console.log(fieldProps.value)
        return (
            <>
                <Flatpickr
                    className='form-control form-control-lg mb-3 mb-lg-0'
                    options={{ 'enable-time': false, dateFormat: "m/d/Y" }}
                    value={new Date(fieldProps.value ?? new Date()).toISOString()}
                    onChange={(date: any) => {
                        dateUpdate(date);
                    }}
                />  
                {touched && errors && (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{errors}</div>
                    </div>
                )}
            </>)
    }

    return (
        <>
            {verticalLabel == true ?
                <a.AncientFormWrapVertical displayText={displayText}>
                    {datePicker()}
                </a.AncientFormWrapVertical>
                :
                <a.AncientFormWrapHorizontal displayText={displayText}>
                    {datePicker()}
                </a.AncientFormWrapHorizontal>
            }   
        </>
    )
}
